import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77f567c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "arrow"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rectangle" }, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small-triangle" }, null, -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "to-address-wrapper"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "to-address-label",
  "data-testid": "to-contract-address"
}
const _hoisted_10 = {
  key: 2,
  class: "to-address-wrapper"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 3,
  class: "to-address-label",
  "data-testid": "to-follower-name"
}
const _hoisted_15 = {
  key: 4,
  class: "to-address-label",
  "data-testid": "to-contract-address"
}
const _hoisted_16 = {
  key: 5,
  class: "to-address-label"
}

import { SupportedStandards } from '@lukso/lsp-smart-contracts'
import { computed, ref, watchEffect } from 'vue'
import makeBlockie from 'ethereum-blockies-base64'

import ProfilePictureCached from '@/popup/components/shared/ProfilePicture/ProfilePictureCached.vue'
import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import { getAssetDetails } from '@/popup/utils/getTokenImages'
import SmartContractIcon from '@/assets/smart-contract.svg'
import NewSmartContractIcon from '@/assets/new-smart-contract.svg'
import { truncateMiddle } from '@/shared/utils'
import { getDataABI } from '@/shared/abis/getDataABI'
import { UpAddress, EoaAddress } from '@/shared/models/Profile'
import { ProfilePictureSizes } from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import { logWarn } from '@/shared/logger'
import { LSP26_FOLLOWER_SYSTEM_CONTRACT_ADDRESS_MAINNET } from '@/shared/config'
import { useAppStore } from '@/popup/store/AppStore'
import {
  LUKSO_MAINNET_CHAIN_ID,
  LUKSO_TESTNET_CHAIN_ID,
} from '@/shared/NetworkUtils'

type Props = {
  from: UpAddress
  to?: UpAddress | EoaAddress
  profileIconSize: ProfilePictureSizes
  isContractDeployment: boolean
  truncateNameLength?: number
  truncateAddressLength?: number
}

enum ToAddressType {
  EOA,
  UP,
  OWN_UP,
  SMART_CONTRACT,
  DIGITAL_ASSET,
  CONTRACT_DEPLOYMENT,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Profiles',
  props: {
    from: {},
    to: {},
    profileIconSize: {},
    isContractDeployment: { type: Boolean },
    truncateNameLength: {},
    truncateAddressLength: {}
  },
  setup(__props: any) {

const props = __props

const { createContract, getWeb3Eth } = useWeb3Eth()
const appStore = useAppStore()
const contractName = ref<string>()
const contractSymbol = ref<string>()
const contractIcon = ref<string>()

const toAddressType = ref<ToAddressType>()

const isLsp26 = computed(() => {
  if (!props.to) {
    return false
  }
  return (
    props.to?.toLowerCase() ===
      LSP26_FOLLOWER_SYSTEM_CONTRACT_ADDRESS_MAINNET.toLowerCase() &&
    (appStore.network.chainId === LUKSO_TESTNET_CHAIN_ID ||
      appStore.network.chainId === LUKSO_MAINNET_CHAIN_ID)
  )
})

const identifyToAddress = async (): Promise<void> => {
  if (props.isContractDeployment || !props.to) {
    toAddressType.value = ToAddressType.CONTRACT_DEPLOYMENT
    return
  }
  if (props.to === props.from) {
    toAddressType.value = ToAddressType.OWN_UP
    return
  }
  const toBytecode = await getWeb3Eth().getCode(props.to)

  if (toBytecode === '0x') {
    //EOA
    toAddressType.value = ToAddressType.EOA
    return
  }
  try {
    const supportedStandard = await createContract(getDataABI, props.to)
      .methods['getData(bytes32)'](SupportedStandards.LSP3Profile.key)
      .call()
    if (supportedStandard === SupportedStandards.LSP3Profile.value) {
      toAddressType.value = ToAddressType.UP
      return
    }
  } catch (e) {
    logWarn(e)
  }
  try {
    const supportedStandard = await createContract(getDataABI, props.to)
      .methods['getData(bytes32)'](SupportedStandards.LSP4DigitalAsset.key)
      .call()

    if (supportedStandard === SupportedStandards.LSP4DigitalAsset.value) {
      toAddressType.value = ToAddressType.DIGITAL_ASSET

      const digitalAsset = await getAssetDetails(props.to)

      contractName.value = digitalAsset?.name
      contractSymbol.value = digitalAsset?.symbol
      contractIcon.value =
        digitalAsset?.icon || (digitalAsset?.images && digitalAsset?.images[0])

      return
    }
  } catch (e) {
    logWarn(e)
  }

  toAddressType.value = ToAddressType.SMART_CONTRACT
}

const smallIdenticon = computed(() => {
  return props.to ? makeBlockie(props.to) : undefined
})

watchEffect(async () => {
  await identifyToAddress()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`profiles ${
      toAddressType.value === ToAddressType.OWN_UP ? 'from-only' : ''
    }`)
  }, [
    _createVNode(ClipboardCopy, {
      value: _ctx.from,
      "has-hover-text": false,
      "offset-distance": "0",
      class: "profile-wrapper"
    }, {
      default: _withCtx(() => [
        _createVNode(ProfilePictureCached, {
          size: _ctx.profileIconSize,
          address: _ctx.from,
          "truncate-name-length": _ctx.truncateNameLength,
          "data-testid": "from"
        }, null, 8 /* PROPS */, ["size", "address", "truncate-name-length"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["value"]),
    (toAddressType.value !== ToAddressType.OWN_UP)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
      : _createCommentVNode("v-if", true),
    (toAddressType.value !== ToAddressType.OWN_UP)
      ? (_openBlock(), _createBlock(ClipboardCopy, {
          key: 1,
          value: _ctx.to,
          "has-hover-text": false,
          "offset-distance": "0",
          class: "profile-wrapper profile-to"
        }, {
          default: _withCtx(() => [
            (
          toAddressType.value === ToAddressType.UP ||
          toAddressType.value === ToAddressType.EOA
        )
              ? (_openBlock(), _createBlock(ProfilePictureCached, {
                  key: 0,
                  size: _ctx.profileIconSize,
                  address: _ctx.to,
                  "truncate-name-length": _ctx.truncateNameLength,
                  "data-testid": "to"
                }, null, 8 /* PROPS */, ["size", "address", "truncate-name-length"]))
              : (toAddressType.value === ToAddressType.DIGITAL_ASSET)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: contractIcon.value || _unref(SmartContractIcon),
                      class: _normalizeClass(["contract-icon", { asset: contractIcon.value }]),
                      alt: ""
                    }, null, 10 /* CLASS, PROPS */, _hoisted_7),
                    _createElementVNode("img", {
                      src: smallIdenticon.value,
                      class: "contract-identicon",
                      "data-testid": "contract-identicon",
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_8),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(truncateMiddle)(
              contractName.value || props.to,
              props.truncateAddressLength,
              props.truncateAddressLength
            )), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (toAddressType.value === ToAddressType.SMART_CONTRACT)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(SmartContractIcon),
                          class: "contract-icon",
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_11))
                      : _createCommentVNode("v-if", true),
                    (toAddressType.value === ToAddressType.SMART_CONTRACT)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: smallIdenticon.value,
                          class: "contract-identicon",
                          "data-testid": "contract-identicon",
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_12))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: _unref(NewSmartContractIcon),
                          class: "contract-icon",
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_13)),
                    (isLsp26.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('confirmation.follower_system')), 1 /* TEXT */))
                      : (toAddressType.value === ToAddressType.SMART_CONTRACT)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(truncateMiddle)(
              props.to,
              props.truncateAddressLength,
              props.truncateAddressLength
            )), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('confirmation.new_smart_contract')), 1 /* TEXT */))
                  ]))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["value"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})